import React, { useState } from 'react';
import {
    Box,
    TextField,
    Button,
    Typography,
    Alert,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Paper
} from '@mui/material';
import { adminApi } from '../../services/api';

const TestingConsole = () => {
    const [email, setEmail] = useState('');
    const [templateId, setTemplateId] = useState(1);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    const handleSendEmail = async () => {
        try {
            setLoading(true);
            setResult(null);

            const response = await adminApi.sendTestEmail(email, parseInt(templateId));

            setResult({
                success: true,
                message: 'Email sent successfully!'
            });
        } catch (error) {
            console.error('Error sending test email:', error);
            setResult({
                success: false,
                message: error.message || 'Failed to send email'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ maxWidth: 600, mx: 'auto', p: 2 }}>
            <Paper sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom>
                    Email Template Testing
                </Typography>
                
                <FormControl fullWidth sx={{ mb: 2 }}>
                    <TextField
                        label="Test Email Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        fullWidth
                        required
                        placeholder="Enter email address to test"
                    />
                </FormControl>

                <FormControl fullWidth sx={{ mb: 3 }}>
                    <TextField
                        label="Template ID"
                        value={templateId}
                        onChange={(e) => {
                            const value = e.target.value;
                            // Only allow positive numbers
                            if (value === '' || /^[1-9]\d*$/.test(value)) {
                                setTemplateId(value);
                            }
                        }}
                        type="number"
                        inputProps={{ min: 1 }}
                        helperText="1: B2C Welcome, 2: Agency Welcome, 3: B2C Reminder 1, 4: Agency Reminder 1, 5: B2C Reminder 2, 6: Agency Reminder 2"
                        placeholder="Enter template ID (1 - 6)"
                    />
                </FormControl>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSendEmail}
                    disabled={loading || !email}
                    fullWidth
                >
                    {loading ? 'Sending...' : 'Send Test Email'}
                </Button>

                {result && (
                    <Alert 
                        severity={result.success ? 'success' : 'error'} 
                        sx={{ mt: 2 }}
                    >
                        {result.message}
                    </Alert>
                )}
            </Paper>
        </Box>
    );
};

export default TestingConsole;